import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTabsModule } from '@angular/material/tabs';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';
import { Tab } from 'app/interfaces/tab.interface';

@Component({
  selector: 'app-page-kpi',
  templateUrl: './page-kpi.component.html',
  styleUrls: ['./page-kpi.component.scss'],
  imports: [MatTabsModule, MatIconModule, RouterLinkActive, RouterLink, RouterOutlet, TranslocoModule],
})
export class PageKpiComponent {
  kpiTabs: Tab[] = [
    {
      label: `TAB_KPI_SUMMARY`,
      path: `summary`,
      icon: 'bar_chart',
    },
    {
      label: `TAB_KPI_DETAILS`,
      path: `details`,
      icon: 'table_chart',
    },
    {
      label: `TAB_KPI_MAP`,
      path: `map`,
      icon: 'map',
    },
  ];
}
